import React, { ReactNode } from "react";
import { ReactComponent as OutlineChevronRight } from "assets/svg/outline-chevron-right.svg";
import { ReactComponent as OutlineChevronLeft } from "assets/svg/outline-chevron-left.svg";
import { ReactComponent as OutlineChevronDoubleRight } from "assets/svg/chevron-double-right.svg";
import { ReactComponent as OutlineChevronDoubleLeft } from "assets/svg/chevron-double-left.svg";
import PAGE_ITEM_TYPES from "../constants/pageItemTypes";

export default function getPageIcon(
  arg: keyof typeof PAGE_ITEM_TYPES,
): ReactNode {
  switch (arg) {
    case PAGE_ITEM_TYPES.ellipsis: {
      return "...";
    }

    case PAGE_ITEM_TYPES.first: {
      return <OutlineChevronDoubleLeft />;
    }

    case PAGE_ITEM_TYPES.previous: {
      return <OutlineChevronLeft />;
    }

    case PAGE_ITEM_TYPES.next: {
      return <OutlineChevronRight />;
    }

    case PAGE_ITEM_TYPES.last: {
      return <OutlineChevronDoubleRight />;
    }

    default:
      return "";
  }
}
